import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-the-header-navi-for-sp-layout" }
const _hoisted_2 = {
  class: "p-the-header-navi-for-sp-layout__drawer",
  ref: "drawerContainer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconHamburger = _resolveComponent("IconHamburger")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_TheHeaderNaviProfilePanel = _resolveComponent("TheHeaderNaviProfilePanel")!
  const _component_HeaderGroupNavi = _resolveComponent("HeaderGroupNavi")!
  const _component_HeaderNaviSwitchButtonForSpLayout = _resolveComponent("HeaderNaviSwitchButtonForSpLayout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: [
        _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
        _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchShownState()))
      ],
      class: "p-the-header-navi-for-sp-layout__button"
    }, [
      _createVNode(_component_IconBase, {
        width: 24,
        height: 24,
        "view-box": "0 0 24 24",
        "icon-color": "#000000"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconHamburger)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
        class: "p-the-header-navi-for-sp-layout__drawer__inner",
        ref: "drawer"
      }, [
        _createVNode(_component_TheHeaderNaviProfilePanel),
        (_ctx.isAdminSite && _ctx.isSp)
          ? (_openBlock(), _createBlock(_component_HeaderGroupNavi, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.isUserAdmin)
          ? (_openBlock(), _createBlock(_component_HeaderNaviSwitchButtonForSpLayout, {
              key: 1,
              onClickChangeModalState: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emitClickEvent()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.switchButton.text), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent), _normalizeProps(_guardReactiveProps(_ctx.currentProperties)), null, 16))
      ], 512)
    ], 512)
  ]))
}